import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface Props {
  field: Field
  readonly: boolean
  onChange: (value: boolean) => void
}

const Restricted = ({ field, onChange }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-restricted-input' }}>
    <Card.Title size="small" action={<TogglerCheckbox value={!field.value} onChange={onChange} />}>
      {i18n.t('settings.leave_types.page.permissions.form.restricted.label')}
    </Card.Title>
    <Card.Description>
      {i18n.t('settings.leave_types.page.permissions.form.restricted.description')}
    </Card.Description>
  </Card>
)

export default Restricted
